import { PET_STORE_BASE_LINK } from '~/common/constants/externalLinks';

export const PET_STORE_LINK = `${PET_STORE_BASE_LINK}/?utm_source=madpaws&utm_medium=futures&utm_campaign=homepage`;
